import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "../../../vapor/tableComplex";
import { CSVLink } from "react-csv";
import { Button } from "@ts-digital/vrc";
import { Input, Select } from "antd";
import React, { useEffect, useCallback, useRef } from "react";
import "./style.css";
import AssetsDrawerDetail from "../accountAssets/drawerDetail";
import { useDispatch, useSelector } from "react-redux";
import { getFixedAssetDetails, getFixedAssetsList } from "../../../../store/actions/precog/assets";
import moment from "moment";
import { VaporRangeDatePicker } from "../../../vapor";
import numeral from "numeral";
import InfiniteScroll from "react-infinite-scroller";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

const { Option } = Select;

const columnsFixedAsset = [
  {
    title: "Descrizione",
    dataIndex: "description",
    key: "description"
  },
  {
    title: "Cod. identificativo",
    dataIndex: "alias",
    key: "alias"
  },
  {
    title: "Data acquisto",
    dataIndex: "purchaseDate",
    key: "purchaseDate"
  },
  {
    title: "Data vendita",
    dataIndex: "saleDate",
    key: "saleDate"
  },
  {
    title: "Valore cespite",
    dataIndex: "amount",
    key: "amount",
    render: (value, obj) => { 
      /** todo chiedere la valuta lato BE */      
      return <span>{numeral(value).format("0,0.00")} €</span>;
    }
  },
  {
    title: "Tot. ammortizzato",
    dataIndex: "accumulatedDepreciation",
    key: "accumulatedDepreciation",
    render: (value, obj) => { 
      /** todo chiedere la valuta lato BE */
      return <span>{numeral(value).format("0,0.00")} €</span>;
    }
  },
  {
    title: "Valore residuo",
    dataIndex: "carryingValue",
    key: "carryingValue",
    render: (value, obj) => { 
      /** todo chiedere la valuta lato BE */
      return <span>{numeral(value).format("0,0.00")} €</span>;
    }
  },
  {
    title: "Stato",
    dataIndex: "status",
    key: "status"
  },
  {
    title: "",
    dataIndex: "button",
    key: "button"
  }
];

// columns in table with sort button
const fieldsWithSort = [];

const FixedAsset = () => { 
  const tableScrollRef = useRef();  
  const [assetsDetails, setAssetsDetails] = React.useState({});
  const [drawerVisible, setDrawerVisible] = React.useState(false);
  const [activeSort, setActiveSort] = React.useState({ key: "", order: "" });
  const [delaySearch, setDelaySearch] = React.useState(null);
  const [fetching, setFetching] = React.useState(false);
  const fixedAssetsObj = useSelector(state => state.precog?.fixedAssets);
  const fixedList = fixedAssetsObj?.list;
  const nextPageUrl = fixedAssetsObj?.nextUrl;

  const dispatch = useDispatch();
  
  useEffect(() => {
    if (!tableScrollRef.current) return undefined;    
    let ps = new Scrollbar(tableScrollRef.current/* , {wheelPropagation: true}*/);
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [tableScrollRef?.current]);
  
  useEffect(() => {    
    
    dispatch(getFixedAssetsList())
      .catch(e =>{
        console.log("Error: ", e);
      });
  }, []);

  const renderSpinner = (
    <div
      style={{ position: "fixed", top: "154px", 
        backgroundColor: "rgba(256,256,256, 0.7)", 
        width: "85%",
        height: "calc(100% - 154px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center", fontSize: "32px", color: "#0090d1" }}
      key={Math.random()}
    >
      <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
    </div>
  );
  
  const fetchAssets = useCallback(() => {    
    if (fetching) {
      return;
    }
    setFetching(true);

    try {
      dispatch(getFixedAssetsList(
        null, null, nextPageUrl
      )).then((res) => {        
        setTimeout(() => {
          setFetching(false);
        }, 500);         
      });
       
    } catch {
      setFetching(false);
    }
  }, [fetching, nextPageUrl]);

  const search = (fields) => {
    if (delaySearch) clearTimeout(delaySearch);
    setDelaySearch(setTimeout(() => {      
      const sendFields = { ...fields };
      if (sendFields.purchaseDate) {
        sendFields.purchaseDateFrom = sendFields.purchaseDate[0]?.format("YYYY-MM-DD");
        sendFields.purchaseDateTo = sendFields.purchaseDate[1]?.format("YYYY-MM-DD");
        delete sendFields.purchaseDate;
      }
      if (sendFields.saleDateTo) {
        sendFields.saleDateFrom = sendFields.saleDate[0]?.format("YYYY-MM-DD");
        sendFields.saleDateTo = sendFields.saleDate[1]?.format("YYYY-MM-DD");
        delete sendFields.saleDateTo;
      }
      
      dispatch(getFixedAssetsList(null, sendFields));       
    }, 500));
  };

  const sort = (key) => {
    if (activeSort.key === key) {
      setActiveSort({ key, order: activeSort.order === "down" ? "up" : "down" });
    } else {
      setActiveSort({ key, order: "down" });
    }
  };

  const openDetails = (
    id, businessId, status
  ) => {
    setDrawerVisible(true);
    dispatch(getFixedAssetDetails(id, businessId))
      .then(res => {              
        setAssetsDetails({...res, id: id, businessId: businessId, assetStatus: status});        
      });
  };

  const useSearchFields = () => {
    const [fields, setFields] = React.useState({
      description: "",
      alias: "",
      purchaseDate: "",
      saleDate: "",
      status: "ALL"
    });

    const handleChange = (field, value) => {
      let newFields = {};
      setFields(prev => {
        newFields = { ...prev, [field]: value };
        return newFields;
      });
      search(newFields);
    };
    return [fields, handleChange];
  };

  const [assetFilters, setAssetFilters] = useSearchFields();

  const columns = columnsFixedAsset.map(c => {    
    if (c.title)
      return {
        title: (<div className="header-col">
          <div className="header-row first">{c.title}
            {fieldsWithSort.includes(c.key) && (<FontAwesomeIcon
              icon={["far", `sort${activeSort.key === c.key && activeSort.order ? "-" + activeSort.order : ""}`]}
              style={{
                cursor: "pointer",
                marginLeft: "2px"
              }}
              onClick={() => sort(c.key)}
            />)}
          </div>
          <div className="header-row second">
            {["alias", "description"].includes(c.key) &&
              (
                <>
                  <Input
                    className="input-search"
                    placeholder="Cerca"
                    value={assetFilters[c.key]}
                    onChange={(e) => setAssetFilters(c.key, e.target.value)}
                  />
                  <FontAwesomeIcon
                    icon={["far", "search"]}
                    style={{}}
                  />
                </>
              )}
            {["purchaseDate", "saleDate"].includes(c.key) &&
              (
                <VaporRangeDatePicker
                  customTrigger={true}
                  placeholder={["Inizio", "Fine"]}
                  className="date-search"
                  onChange={(value) => {
                    if (value) {
                      const from = value[0];
                      const to = value[1];
                      if ((from && to))
                        setAssetFilters(c.key, [from, to]);
                    } else {
                      setAssetFilters(c.key, "");
                    }
                  }}
                />
              )}
            {c.key === "status" && (
              <Select value={assetFilters[c.key]} onChange={value => {
                setAssetFilters(c.key, value);
              }} className={"select-search"}>
                {[{ value: "ALL", label: "Tutti" }, { value: "ACTIVE", label: "Attivo" }, { value: "NOT_ACTIVE", label: "Non attivo" }].map(s => (
                  <Option key={s.value} value={s.value}>{s.label}</Option>
                ))}
              </Select>
            )}
          </div>
        </div>),
        dataIndex: c.dataIndex,
        key: c.key,
        render: c.render
      };
    return {
      title: (<div className="header-col">
        <div className="header-row first">
        </div>
        <div className="header-row second">
        </div>
      </div>),
      dataIndex: c.dataIndex,
      key: c.key
    };
  });

  return (
    <div className="fixed-asset">

      {drawerVisible &&
        <AssetsDrawerDetail
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          assetsDetails={assetsDetails}
          getAssetInfo={false}
          readOnly={true}
          showToggle={false}
          isListAssets={true}
        />
      }
      <header>
        <div className="right">
          <div className="col">
            <div className="label">Tot cespiti</div>
            <div className="value">{(numeral(Math.abs(fixedAssetsObj?.totals?.totalAmount)).format("0,0.00") || "0") + "€"}</div>
          </div>
          <div className="col">
            <div className="label">Tot ammortizzati</div>
            <div className="value">{(numeral(Math.abs(fixedAssetsObj?.totals?.totalDepreciatedAmount)).format("0,0.00") || "0") + "€"}</div>
          </div>
          <div className="col">
            <div className="label">Valore residuo tot.</div>
            <div className="value">{(numeral(Math.abs(fixedAssetsObj?.totals?.totalResidualAmount)).format("0,0.00") || "0") + "€"}</div>
          </div>
        </div>
        <div className="left">
          {!fixedAssetsObj.status.started  && <CSVLink
            data={fixedList || []}
            filename={
              new Date().toDateString().replaceAll(" ", "_") + ".csv"
            }
          >
            <Button kind="secondary">
              <FontAwesomeIcon
                icon={["far", "download"]}
                style={{
                  marginRight: 10,
                  color: "#0090d1",
                  cursor: "pointer"
                }}
              />
              Download CSV
            </Button>
          </CSVLink>}
        </div>
      </header>
      <div className="tableAreaScrollable fixedAsset" ref={tableScrollRef}>
        <InfiniteScroll
          // style={{height: "calc(100vh - 200px  20px)"}}
          // style={{height: "100vh"}}
          inverse={false}
          initialLoad={window.innerHeight > 1032 ? true : false}
          threshold={420}
          pageStart={1}
          loadMore={() => {
            if (!fixedAssetsObj.status.started && !!nextPageUrl)
              fetchAssets();
          }}
          getScrollParent={() => document.querySelector("#dbx-main-container")
          // </div></div>tableScrollRef.current;          
          
          }   
          loader={fixedAssetsObj.status.started && renderSpinner} 
          hasMore={!!nextPageUrl}
          useWindow={false}
        >
          <Table columns={columns}
            dataSource={fixedList?.map(a => {
              // Add button to open details to data
              return {
                ...a,
                purchaseDate: a.purchaseDate ? moment(a.purchaseDate).format("DD/MM/YYYY") : "",
                saleDate: a.saleDate ? moment(a.saleDate).format("DD/MM/YYYY") : "",
                status: a.status === "ACTIVE" ? "Attivo" : "Non attivo",
                button: (<FontAwesomeIcon
                  icon={["far", "external-link-square"]}
                  style={{
                    color: "#0090d1",
                    cursor: "pointer"
                  }}
                  onClick={() => {                
                    openDetails(
                      a.id, a.businessId, a.status
                    );
                  }}
                />)
              };
            })}
          />
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default FixedAsset;
